export default __webpack_public_path__ + "static/media/lili.747eca46.svg";